import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { blogPosts, BlogPost } from '../../data/blogPosts';
import { createSlug } from '../../utils/slug';
import './BlogDetail.css';

const BlogDetail: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const post = blogPosts.find(p => createSlug(p.title) === slug);

  if (!post) {
    return (
      <div className="container" style={{ padding: '100px 0', textAlign: 'center' }}>
        <h2>Bài viết không tìm thấy</h2>
        <Link to="/" className="btn-primary">Về trang chủ</Link>
      </div>
    );
  }

  return (
    <div className="blog-detail-page">
      <div className="container">
        {/* Breadcrumb */}
        <div className="breadcrumb">
          <Link to="/">Trang chủ</Link> / <Link to="/#blog">Blog</Link> / <span>{post.title}</span>
        </div>

        {/* Blog Header */}
        <div className="blog-header">
          <h1 className="blog-title">{post.title}</h1>
          <div className="blog-meta-detail">
            <span>bởi {post.author}</span>
            <span>{post.date}</span>
            <span>{post.comments} bình luận</span>
            <span className="blog-category">{post.category}</span>
          </div>
        </div>

        {/* Blog Image */}
        <div className="blog-featured-image">
          <img src={post.image} alt={post.title} />
        </div>

        {/* Blog Content */}
        <div className="blog-content" dangerouslySetInnerHTML={{ __html: post.content }} />

        {/* Share Section */}
        <div className="blog-share">
          <h4>Chia sẻ với chúng tôi:</h4>
          <div className="share-buttons">
            <a href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}`} target="_blank" rel="noopener noreferrer" className="share-btn facebook">
              <i className="fab fa-facebook-f"></i>
            </a>
            <a href={`https://pinterest.com/pin/create/button/?url=${encodeURIComponent(window.location.href)}`} target="_blank" rel="noopener noreferrer" className="share-btn pinterest">
              <i className="fab fa-pinterest"></i>
            </a>
            <a href={`https://www.instagram.com/`} target="_blank" rel="noopener noreferrer" className="share-btn instagram">
              <i className="fab fa-instagram"></i>
            </a>
          </div>
        </div>

        {/* Navigation */}
        <div className="blog-navigation">
          <div className="nav-previous">
            {blogPosts.findIndex(p => createSlug(p.title) === slug) > 0 && (
              <Link to={`/blog/${createSlug(blogPosts[blogPosts.findIndex(p => createSlug(p.title) === slug) - 1].title)}`}>
                ← Bài viết trước
              </Link>
            )}
          </div>
          <div className="nav-next">
            {blogPosts.findIndex(p => createSlug(p.title) === slug) < blogPosts.length - 1 && (
              <Link to={`/blog/${createSlug(blogPosts[blogPosts.findIndex(p => createSlug(p.title) === slug) + 1].title)}`}>
                Bài viết tiếp theo →
              </Link>
            )}
          </div>
        </div>

        {/* Comments Section - Tạm ẩn */}
        {/* <div className="blog-comments">
          <h3>{post.comments} bình luận</h3>
          <div className="comment-form">
            <h4>Để lại bình luận</h4>
            <form>
              <div className="form-group">
                <input type="text" placeholder="Tên" required />
              </div>
              <div className="form-group">
                <input type="email" placeholder="Email" required />
              </div>
              <div className="form-group">
                <textarea placeholder="Nội dung bình luận" rows={5} required></textarea>
              </div>
              <button type="submit" className="btn-submit-comment">Gửi bình luận</button>
            </form>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default BlogDetail;

